<template lang="html">
  <section class="app-update-project">
    <p class="text-success" v-if="messageSubmission">
      <strong>{{ messageSubmission }}</strong>
    </p>
    <p v-if="!getCurrentElement">
      Please go first to the "<a href="#" @click="navigateAway('read')"><strong><em>Read</em></strong></a>"
      tab and select the award you would like to update.
    </p>
    <form v-else @submit.prevent="onSubmit" class=" text-left" :class="$v.dataForm.$invalid ? '':'was-validated'">
      <div class="form-group d-flex">
        <label for="projectTitle" class="w-25 align-self-center">* Title :</label>
        <div class="w-100">
          <input @blur="$v.dataForm.projectTitle.$touch() || (dataForm.projectTitle = (dataForm.projectTitle === '') ? savedData.title : dataForm.projectTitle)"
                 v-model="dataForm.projectTitle"
                 :class="$v.dataForm.projectTitle.$error ? 'is-invalid': ''" id="projectTitle"
                 type="text" class="form-control">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectTitle.required">Please enter the title of the project !</div>
            <div v-if="!$v.dataForm.projectTitle.minLength">
              Project title is too short and may not be correct !
              Enter at least {{$v.dataForm.projectTitle.$params.minLength.min}} letters.
            </div>
            <div v-if="!$v.dataForm.projectTitle.maxLength">
              Project title is too long ({{$v.dataForm.projectTitle.$params.maxLength.max}} letters) ! Try to make it short !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectTypeId" class="w-25 align-self-center">* Type of project :</label>
        <div class="w-100">
          <select  :class="$v.dataForm.projectTypeId.$error ? 'is-invalid': ''"
                   @blur="$v.dataForm.projectTypeId.$touch()" v-model="dataForm.projectTypeId"
                   id="projectTypeId" class="custom-select">
            <option :value="projects_type.project_type_id" :key="projects_type.project_type_id" class="text-capitalize"
                    v-for="projects_type of getProjectsTypes">{{ projects_type.type }}</option>
          </select>
          <div class="invalid-feedback">Please select a category of your project !</div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectLinkProject" class="w-25 align-self-center">* Link Project :</label>
        <div class="w-100">
          <input :class="$v.dataForm.projectLinkProject.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.projectLinkProject.$touch() || (dataForm.projectLinkProject = (dataForm.projectLinkProject === '') ? savedData.link_project : dataForm.projectLinkProject)"
                 v-model="dataForm.projectLinkProject"
                 type="url" class="form-control" id="projectLinkProject">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectLinkProject.required">Please provide a link of your project !</div>
            <div v-if="!$v.dataForm.projectLinkProject.url">Please enter a valid link of your project !</div>
            <div v-if="!$v.dataForm.projectLinkProject.maxLength">
              The link is too long (more than {{$v.dataForm.projectLinkProject.$params.maxLength.max}} characters) !
              Please try to shorten it !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectLinkOverview" class="w-25 align-self-center">* Link Overview :</label>
        <div class="w-100">
          <input :class="$v.dataForm.projectLinkOverview.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.projectLinkOverview.$touch() || (dataForm.projectLinkOverview = (dataForm.projectLinkOverview === '') ? savedData.link_overview : dataForm.projectLinkOverview)"
                 v-model="dataForm.projectLinkOverview"
                 type="text" class="form-control" id="projectLinkOverview">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectLinkProject.required">Please provide a link of the overview of your project !</div>
            <div v-if="!$v.dataForm.projectLinkOverview.url">Please enter a valid link of the overview of your project !</div>
            <div v-if="!$v.dataForm.projectLinkOverview.maxLength">
              The link is too long (more than {{$v.dataForm.projectLinkOverview.$params.maxLength.max}} characters) !
              Please try to shorten it !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectDescription" class="w-25 align-self-center">* Description :</label>
        <div class="w-100">
          <textarea :class="$v.dataForm.projectDescription.$error ? 'is-invalid': ''"
                    @blur="$v.dataForm.projectDescription.$touch() || (dataForm.projectDescription = (dataForm.projectDescription === '') ? savedData.description : dataForm.projectDescription)"
                    v-model="dataForm.projectDescription"
                    class="form-control" id="projectDescription" placeholder="Enter text here...">
          </textarea>
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectDescription.required">Please enter a description of your project !</div>
            <div v-if="!$v.dataForm.projectDescription.minLength">
              The Description is too short ! Try to enter more than
              {{$v.dataForm.projectDescription.$params.minLength.min}} characters !
            </div>
          </div>
        </div>
      </div>
      <div class="form-group d-flex">
        <label for="projectTeammates" class="w-25 align-self-center">Teammates :</label>
        <div class="w-100">
          <input :class="$v.dataForm.projectTeammates.$error ? 'is-invalid': ''"
                 @blur="$v.dataForm.projectTeammates.$touch() || (dataForm.projectTeammates = (dataForm.projectTeammates === '') ? savedData.teammates : dataForm.projectTeammates)"
                 v-model="dataForm.projectTeammates"
                 type="text" class="form-control" id="projectTeammates">
          <div class="invalid-feedback">
            <div v-if="!$v.dataForm.projectTeammates.minLength">
              Please make sure you enter valid full name(s) of your teammates !
              <br>This field can't contain ({{$v.dataForm.projectTeammates.$params.minLength.min}}) characters or less !
            </div>
            <div v-if="!$v.dataForm.projectTeammates.maxLength">
              You have exceeded the number of characters ({{$v.dataForm.projectTeammates.$params.maxLength.max}})
              allowed for this field !
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4 mb-4 text-center">
        <button type="submit" class="btn btn-success">Submit</button>
        <button type="button" class="btn btn-danger ml-3">Reset</button>
      </div>
    </form>
  </section>
</template>

<script lang="js">
import {mapGetters, mapActions} from "vuex";
import {FORM_PROJECTS_VALIDATIONS} from '../../validations/formProjects'
export default {
  name: 'UpdateProject',
  props: [],
  mounted () {},
  created () {
    this.axiosGet({component: 'projects_types', state: 'listProjectsTypes'});
    this.readOneData()
      .then(data => {
        this.savedData = data;
        this.dataForm.projectTypeId = this.savedData.project_type_id;
        this.dataForm.projectTitle = this.savedData.title;
        this.dataForm.projectLinkProject = this.savedData.link_project;
        this.dataForm.projectLinkOverview = this.savedData.link_overview;
        this.dataForm.projectDescription = this.savedData.description;
        this.dataForm.projectTeammates = this.savedData.teammates;
      })
      .catch()
  },
  validations: FORM_PROJECTS_VALIDATIONS,
  data () {
    return {
      savedData : null,
      dataForm : {
        projectTypeId : undefined,
        projectTitle: undefined,
        projectLinkProject : undefined,
        projectLinkOverview : undefined,
        projectDescription : undefined,
        projectTeammates : undefined
      },
      messageSubmission: ""
    }
  },
  methods: {
    ...mapActions([
      'setOperation',
      'setCrudComponent',
      'readOneData',
      'updateData',
      'axiosGet'
    ]),
    navigateAway(tab) {
      this.setOperation(tab);
      this.setCrudComponent('app-' + tab + '-' + this.getComponent);
    },
    onSubmit () {
      const formData = {
        project_id : (this.getCurrentElement) ? this.getCurrentElement.id : '',
        project_type_id: this.dataForm.projectTypeId,
        title: this.dataForm.projectTitle,
        link_project: this.dataForm.projectLinkProject,
        link_overview: this.dataForm.projectLinkOverview,
        description: this.dataForm.projectDescription,
        teammates: this.dataForm.projectTeammates
      };
      this.updateData(formData)
        .then(data => {
          this.messageSubmission = data;
          setTimeout( () => this.messageSubmission = '', 5000);
        })
        .catch()
    },
    resetForm () {
      this.dataForm.projectTypeId = this.savedData.project_type_id;
      this.dataForm.projectTitle = this.savedData.title;
      this.dataForm.projectLinkProject = this.savedData.link_project;
      this.dataForm.projectLinkOverview = this.savedData.link_overview;
      this.dataForm.projectDescription = this.savedData.description;
      this.dataForm.projectTeammates = this.savedData.teammates;
    }
  },
  computed: {
    ...mapGetters([
      'getComponent',
      'getProjectsTypes',
      'getCurrentElement'
    ])
  }
}
</script>

<style scoped lang="scss">
  .app-update-project {}
</style>



// WEBPACK FOOTER //
// src/components/projects/UpdateProject.vue